import React from 'react';

import SocialAccountPage from './SocialAccountPage';

export default function GoogleSocialAccount() {
  return <SocialAccountPage type="GOOGLE" />;
}
